import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import { getRecentQueryOptions } from './recentQueryHelpers.ts';
import useRecentPreferencesHomeRecentUserPreferencesQuery, {
	type useRecentPreferencesHomeRecentUserPreferencesQuery$data,
	type useRecentPreferencesHomeRecentUserPreferencesQuery$variables,
} from './__generated__/useRecentPreferencesHomeRecentUserPreferencesQuery.graphql.ts';

export const preloadRecent = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled,
	isWhiteboardUpdatedEnabled,
	isDatabaseEnabled,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isWhiteboardUpdatedEnabled?: boolean;
	isDatabaseEnabled?: boolean;
}): Promise<void | Error[] | {}[]> => {
	const isDatabaseEnabledResolved =
		isDatabaseEnabled ?? isContentTypeEnabledInCurrentEnv('database');

	return waitForAllReturnWhenError([
		queryAgg<unknown, {}>(
			getRecentQueryOptions({
				pill: 'all',
				cloudId,
				endCursor: '',
				isWhiteboardViewedEnabled,
				isWhiteboardUpdatedEnabled,
				isDatabaseEnabled: isDatabaseEnabledResolved,
			}),
		),
		preloadOptions({ isLoggedIn }),
		...(isLoggedIn
			? [
					query<
						useRecentPreferencesHomeRecentUserPreferencesQuery$data,
						useRecentPreferencesHomeRecentUserPreferencesQuery$variables
					>({ query: useRecentPreferencesHomeRecentUserPreferencesQuery }),
				]
			: []),
	]);
};
